/**
 * 一覧の下の「さらに読み込む」（2026-10-04 console/limits-ui）。状態は hooks.ts の usePagedResource の more。
 * 見た目と失敗の出し方は PlayersPage の「さらに読み込む」と同じ（失敗を出さないと、押しても何も起きないように見える）。
 * 次のページが無ければ何も出さない。
 */
import type { MoreState } from '../hooks';
import { useT } from '../i18n';
import { ErrorState } from './ui';

export function LoadMore({ more }: { more: MoreState }) {
  const { t } = useT();
  if (!more.has) return null;
  return (
    <div className="load-more">
      {more.error && <ErrorState error={more.error} onRetry={more.load} />}
      <button type="button" className="btn btn-ghost" onClick={more.load} disabled={more.loading}>
        {more.loading ? t('common.loadingMore') : t('common.loadMore')}
      </button>
    </div>
  );
}
